import React from "react";
import { Truck } from "lucide-react";

export function D1Logo({ className = "", showText = true, variant = "light" }) {
  const text = variant === "light" ? "text-slate-900" : "text-slate-50";
  const sub = variant === "light" ? "text-slate-500" : "text-slate-400";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="d1-logo">
      <div className="relative">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-blue-900 to-blue-600 shadow-lg shadow-blue-900/30">
          <Truck className="h-5 w-5 text-white" strokeWidth={2.5} />
        </div>
        <span className="absolute -bottom-1 -right-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-amber-400 text-[10px] font-bold text-slate-900">
          1
        </span>
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-display text-xl font-extrabold tracking-tight ${text}`}>
            D1 <span className="text-blue-600">Logística</span>
          </span>
          <span className={`mt-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${sub}`}>
            Torre de Controle
          </span>
        </div>
      )}
    </div>
  );
}
